/**
 * Evita volver a preguntar en la misma pestaña si el usuario ya confirmó
 * en qué punto opera mientras hay una sesión de caja abierta.
 */
const PREFIX = "altenot_caja_ingress_ack_";

export function getCajaIngressStorageKey(userId: string | undefined): string {
  return `${PREFIX}${userId || "anon"}`;
}

export function markCajaIngressAcknowledged(userId: string | undefined): void {
  if (!userId) return;
  try {
    sessionStorage.setItem(getCajaIngressStorageKey(userId), "1");
  } catch {
    /* ignore */
  }
}

export function hasCajaIngressAcknowledged(
  userId: string | undefined,
): boolean {
  if (!userId) return true;
  try {
    return sessionStorage.getItem(getCajaIngressStorageKey(userId)) === "1";
  } catch {
    return true;
  }
}

export function clearCajaIngressAcknowledgment(
  userId: string | undefined,
): void {
  if (!userId) return;
  try {
    sessionStorage.removeItem(getCajaIngressStorageKey(userId));
  } catch {
    /* ignore */
  }
}

export function clearAllCajaIngressAcknowledgments(): void {
  try {
    const toRemove: string[] = [];
    for (let i = 0; i < sessionStorage.length; i++) {
      const k = sessionStorage.key(i);
      if (k?.startsWith(PREFIX)) toRemove.push(k);
    }
    toRemove.forEach((k) => sessionStorage.removeItem(k));
  } catch {
    /* ignore */
  }
}
